import * as React from "react";
import { Authorization } from "../utils/authorization";
import { Utilities } from "../utils/utilities";

export interface AppContext {
    history: any;
    apis?: any;
    commonAPI?: any;
    user?: any;
    utils: Utilities;
    lead?: any;
    offer?: any;
    setOffer?: any;
    setLead?: any;
    base?: string;
    authKeeper: Authorization;
    leadError?: object;
    setLeadError?: any;
}
export let appContext: AppContext = {
    history: null,
    apis: {},
    user: null,
    utils: null,
    authKeeper: null,
};
export default React.createContext(appContext);
